import React from 'react';

interface QuarterSelectorProps {
  periods: string[];
  activeQuarter: string;
  onSelectQuarter: (quarter: string) => void;
}

const QuarterSelector: React.FC<QuarterSelectorProps> = ({ periods, activeQuarter, onSelectQuarter }) => (
  <div className="w-full flex flex-row gap-2 sm:gap-4 px-3 py-3.5 sticky -top-px z-30 bg-[#19133c] justify-center shadow-[0_-1px_0_0_#19133c]">
    {[...periods].map((q) => (
      <div key={q} className="relative w-1/5 sm:w-auto flex flex-col items-center">
        <button
          className={`px-3 sm:px-8 py-1.5 text-sm sm:text-xl w-full md:w-32 font-semibold ${
            activeQuarter === q ? 'bg-[#7fe526] text-black z-10' : 'bg-[#255393] text-white'
          }`}
          onClick={() => onSelectQuarter(q)}
        >
          {q}
        </button>
        {activeQuarter === q && (
          <div
            className="absolute left-1/2 -translate-x-1/2 top-full w-0 h-0 z-10
            border-l-[12px] border-l-transparent
            border-r-[12px] border-r-transparent
            border-t-[9px] border-t-[#7fe526]"
          />
        )}
      </div>
    ))}
  </div>
);

export default QuarterSelector;
